<template>
  <queue-calls-viewer :customer-calls="customerCalls" :accounts="accounts" />
</template>

<script>
import QueueCallsViewer from "../components/QueueCallsViewer";

let refreshInterval = null;

export default {
  name: "QueueCalls",
  data: () => {
    return {
      customerCalls: [],
      accounts: [],
    };
  },
  components: {
    QueueCallsViewer,
  },
  mounted() {
    refreshInterval = setInterval(this.refreshCalls, 1500);
    this.refreshCalls();

    this.$http
      .get(`${process.env.VUE_APP_API_URL}accounts`)
      .then((response) => {
        this.accounts = response.body;
      })
      .catch(console.error);
  },
  unmounted() {
    if (refreshInterval) clearInterval(refreshInterval);
    return true
  },
  methods: {
    refreshCalls() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}queuecalls`)
        .then((response) => {
          this.customerCalls = response.body;
        })
        .catch(console.error);
    },
  },
};
</script>
